/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import {is_breakpoint_up} from "../helpers/functions";
import InfiniteScroll from "infinite-scroll";
import axios from 'axios';
import partialOffersConfigEvents from '../partials/offers-config';
import partialFiltersTypesEvents from "../partials/filters";
import App from '../helpers/app';
import PerfectScrollbar from "perfect-scrollbar";
import {createEcommerceImpression, sendEcommerceTags} from "../helpers/datalayer";

$(function () {
    let $infiniteScroll;

    function initOffersInfiniteScrollEvents(){
        if(!$infiniteScroll){
            return;
        }

        if($('.infinite-scroll .pagination .next:not(.disabled)').length){
            let page = 0;
            let match = /page=(\d+)/.exec($('.infinite-scroll .pagination .active a').attr('href'));
            if (match != null) {
                page = match[1];
            }

            if(page>=10000){
                $infiniteScroll.option({
                    loadOnScroll: false,
                });

                if($('.infinite-scroll .pagination .next:not(.disabled)').length){
                    $('.infinite-scroll .show-more').show();
                }else{
                    $('.infinite-scroll .show-more').hide();
                }
            }else{
                $infiniteScroll.option({
                    loadOnScroll: true,
                });

                $('.infinite-scroll .show-more').hide();
            }
        }else{
            $infiniteScroll.option({
                loadOnScroll: false,
            });

            $('.infinite-scroll .show-more').hide();
        }
    }

    let $forceUpdate = 0;
    function initOffersEvents(){
        let $section = $('.section-offers-list');
        if(!$section.length){
            return;
        }

        $section.find('form [name]:not([name*="slider"])').change(function(){
            let name = $(this).attr('name').substring($(this).attr('name').indexOf('[')+1, $(this).attr('name').indexOf(']'));
            let value = $(this).val();
            let pathNames = $.address.pathNames();

            $(document).trigger('param:change', [pathNames[0], name, value, $(this).is('[type="checkbox"]') ? $(this).is(':checked') : true]);
        });

        let $html = $('html');
        $section.find('.offer-config .group-filter a').click(function (e) {
            $html.toggleClass('filters-opened');
            e.preventDefault();
        });

        let $opener = $section.find('.open-filters');
        let $filtersContainer = $section.find('.offer-filters-container');

        $opener.click(function () {
            $html.addClass('filters-opened');
        });

        $filtersContainer.find('.filters-close').click(function(){
            $html.removeClass('filters-opened');

            updateFilters($.address.value());
        });

        $section.find('.offer-filters-selected .filter-delete').click(function(e){
            e.preventDefault();

            $.address.value($(this).attr('href'));
        });

        function updateSortAddress(){
            let $sortDir = $sort.find('[name="DynamicModel[dir]"]:checked').val()=='desc'?'-':'';
            let $sortBy = $sort.find('[name="DynamicModel[by]"]:checked').val();

            $.address.parameter('page', '');
            $.address.parameter('per-page', '');
            $.address.parameter('promoted', '');
            $.address.parameter('sort', $sortDir+''+$sortBy);
        }

        function updateFilters(url){
            App.loader.init($section.find('.offer-filters-footer .btn'));

            axios.get(url)
                .then(function (response) {
                    let html = $(response.data.page.html);

                    $section.find('.offer-filters-footer').empty().append(html.find('.offer-filters-footer .btn'));

                    initFiltersEvents();
                });
        }

        let $sort = $section.find('.offers-sort');
        $sort.find('input').off().change(function(){
            let el = $(this);
            if(el.attr('name')=='DynamicModel[by]'){
                if($sort.find('[name="DynamicModel[dir]"]:checked').val()!=el.data('default-dir')){
                    $sort.find('[name="DynamicModel[dir]"][value="'+el.data('default-dir')+'"]').prop('checked', true).change();
                    $sort.find('[name="DynamicModel[dir]"][value="'+el.data('default-dir')+'"]').parent().click();
                }
            }

            $.address.autoUpdate(false);

            updateSortAddress();

            $.address.update();
            $.address.autoUpdate(true);
        });

        let $form = $section.find('form');
        $form.off().submit(function (e) {
            e.preventDefault();

            let checked = $form.find('[name*="body_type"]:checked');
            if(checked.length===1){
                let first = checked.first();
                if(first.attr('name').indexOf('body_type')!==-1 && first.val()==='furgon_group'){
                    let path = $.address.pathNames();
                    if(path[0]==='dostawcze'){
                        return false;
                    }
                    path.unshift('dostawcze');
                    $.address.autoUpdate(false);
                    $.address.path(path.join('/'));
                    $.address.parameter('body_type', '');
                    window.location.href = $.address.value();
                    return false;
                }
            }

            let actualAddress = $.address.value();

            let formData = $(this).serializeArray();

            $.address.autoUpdate(false);

            $.each($.address.parameterNames(), function(k, v){
                $.address.parameter(v, '');
            });

            let data = {};
            $.each(formData, function(k, v){
                if(v.name.indexOf('DynamicModel')!==-1){
                    return true;
                }

                let name = v.name.replace('SearchOfferForm', 'f');
                name = name.replace('[]', '').replace('f[', '').replace(']', '');

                if(typeof data[name]==='undefined'){
                    data[name] = [];
                }

                if(v.value==''){
                    return true;
                }

                data[name].push(v.value);
            });

            $.each(data, function(k, v){
                v = v.join(',');

                if($.inArray(k, ['offer_type', 'finance_type', 'monthly_price'])!==-1){
                    return true;
                }

                $.address.parameter(k, v);
            });

            let canonical = $('head link[rel="canonical"]').attr('href').replace('http://','').replace('https://','').replace('www.','').split(/[/?#]/).splice(1).join('/');
            let pathNames = $.address.pathNames();
            let path = canonical ? '/'+canonical : '/'+pathNames[0];
            if(typeof data['offer_type'] !== 'undefined'){
                path += '/'+data['offer_type'].join(',')+','+data['finance_type'].join(',')+','+data['monthly_price'].join(',');
            }

            $.address.path(path);

            updateSortAddress();

            let newAddress = $.address.value();

            if(is_breakpoint_up('xl') || $forceUpdate){
                $.address.update();
            }else{
                $.address.value(actualAddress);

                updateFilters(newAddress);
            }

            $.address.autoUpdate(true);

            $forceUpdate = 0;

            return false;
        });


        let $infiniteScrollContainer = $('.infinite-scroll .offer-list');
        let $infiniteScrollContainerAppends = $('.infinite-scroll .appended-items');

        if($infiniteScrollContainer.length){
            $infiniteScroll = new InfiniteScroll($infiniteScrollContainer[0], {
                path: function() {
                    let pagination = $('.infinite-scroll .pagination .next:not(.disabled) a');
                    if(pagination.length){
                        return pagination.attr('href');
                    }
                },
                append: false,
                responseType: 'json',
                scrollThreshold: 100,
                button: '.infinite-scroll .show-more',
                status: '.infinite-scroll .page-load-status',
                loadOnScroll: false,
                debug: false,
                history: false,
                checkLastPage: true,
            });

            $infiniteScroll.on( 'load', function( response, path ) {
                let html = $(response.page.html);
                let $offerItems = html.find('.infinite-scroll .offer-list .offer-item');
                let $appends = html.find('.infinite-scroll .appended-items').children();

                $infiniteScrollContainer.append($offerItems);
                $infiniteScrollContainerAppends.append($appends);

                $('.infinite-scroll .pagination').remove();

                var pagination = html.find('.infinite-scroll .pagination');
                if(pagination.length){
                    $('.infinite-scroll').append(pagination);
                }

                initOffersInfiniteScrollEvents();

                App.init($infiniteScrollContainer);

                sendEcommerceTags($offerItems);
            });

            initOffersInfiniteScrollEvents();
        }
    }

    function initFiltersGroupEvents(){
        let $section = $('.section-offers-list');
        if(!$section.length){
            return;
        }

        let $offerConfig = $('.offer-config');
        let $offerFilters = $('.offer-filters');

        let ps = null;
        if(is_breakpoint_up('xl')){
            if(ps!==null){
                ps.destroy();
                ps = null;
            }

            let $groupBody = $offerFilters.find('.filter-group-body_type');
            if($groupBody.length){
                $offerConfig.prepend($groupBody.detach());
            }
        }else{
            if(ps===null){
                ps = new PerfectScrollbar($section.find('.offer-filters-body-container')[0]);
            }

            let $groupBody = $offerConfig.find('.filter-group-body_type');
            if($groupBody.length){
                $offerFilters.prepend($groupBody.detach());
            }
        }
    }

    function initFiltersEvents(){
        let $section = $('.section-offers-list');
        if(!$section.length){
            return;
        }

        let $html = $('html');
        let $form = $section.find('form');

        $section.find('.filter-group-finance .filter .filter-body').on('show.bs.collapse', function(){
            App.registerApp($section.find('.offer-config'));
        });

        $section.find('.filter .filter-body').on('shown.bs.collapse', function(){
            if($(this).find('.filter-type-button').length){
                App.registerApp($(this).find('.filter-body-content'));
            }
        });
        $section.find('.filter .filter-body').on('shown.bs.collapse hidden.bs.collapse', function(){
            if($(this).find('.filter-type-checkbox').length){
                let filterSwiper = $(this).find('.swiper-container-initialized');
                if(filterSwiper.length){
                    let filterSwiperInstance = filterSwiper[0].swiper;
                    if(filterSwiperInstance){
                        filterSwiperInstance.update();
                    }
                }
            }
        });

        $section.find('.offer-filters-footer .btn').click(function(e){
            $forceUpdate = 1;
            $form.submit();

            $html.removeClass('filters-opened');
        });

        initFiltersGroupEvents();
        $(window).resize(function(){
            initFiltersGroupEvents();
        });
    }

    function initDynamicEvents(){
        let $section = $('.section-offers-list');
        if(!$section.length){
            return;
        }

        initFiltersEvents();
        initOffersEvents();
        partialOffersConfigEvents();
        partialFiltersTypesEvents();
    }

    initDynamicEvents();

    function initEvents(){
        let $section = $('.section-offers-list');
        if(!$section.length){
            return;
        }

        if(is_breakpoint_up('xl')){
            let $btn = $section.find('.offer-config .group-filter .btn');
            if($btn.is(':visible')){
                $btn.click();
            }
        }

        sendEcommerceTags($section.find('.offer-list .offer-item'));

        let prevUrl = {value: $.address.value()};
        $.address.change(function(e){
            let url = $.address.details(e);

            if(prevUrl.value!=url.value){
                prevUrl = url;

                $(document).trigger('address:change', [$.address.details(e)]);

                axios.get($.address.value())
                    .then(function (response) {
                        if($infiniteScroll){
                            $infiniteScroll.destroy();
                            $infiniteScroll = null;
                        }

                        let block = $('.app-content');
                        let html = $(response.data.page.html);

                        block.find('.section-offers-list').remove();
                        block.prepend(html.filter('.section-offers-list'));

                        $(document).trigger('csm:params-changed', [$('form')]);

                        initDynamicEvents();

                        App.init(block);

                        sendEcommerceTags($section.find('.offer-list .offer-item'));
                    });
            }
        });
    }

    initEvents();
});
